import { checkIfCustomInfoExist, select } from "@utils/function";
import Smarquee from "smarquee";

export default function MessageInfo(action = "init") {
  const customInfo = select(".custom-info");

  HQ.Properties.liveScoringMess = HQ.Properties.liveScoringMess?.trim();

  if (!HQ.Properties.liveScoringMess) {
    if (customInfo) {
      customInfo.remove();
      document.body.removeAttribute("data-info");
      document.documentElement.style.setProperty(
        "--custom-info-height",
        checkIfCustomInfoExist()
      );
    }
  }

  // if (!HQ.Properties.liveScoringMess) return;
  if (!HQ.Properties.liveScoringMess) return;

  const config = {
    selector: ".custon-info-message",
    // distance: 0,
    styleOptions: {
      scrollingTitleMargin: 10,
      delay: "1s",
    },
  };

  // -------------------------------------------------
  // scrolling text info in red div

  const messagePartner = select(".message-partner");
  const customInfoText = customInfo?.dataset.customInfoText;

  if (HQ.Properties.liveScoringMess !== customInfoText) {
    if (action === "init" || customInfo == null) {
      // console.log("init");

      const custominfo = select(".custom-info");
      custominfo?.remove();

      messagePartner.insertAdjacentHTML(
        "afterbegin",
        templateMessage(HQ.Properties.liveScoringMess)
      );
    }

    const customInfo = select(".custom-info");
    if (customInfo) {
      document.body.setAttribute("data-info", true);
    }

    let smarquee = new Smarquee();

    smarquee.assignSettings(config);
    smarquee.init();

    if (action === "update" && customInfo) {
      // console.log("update");
      customInfo.setAttribute(
        "data-custom-info-text",
        HQ.Properties.liveScoringMess
      );
    }
  }
}

/**
 * Template message
 *
 * @param {string} text
 */
function templateMessage(text) {
  const textData = text;

  // check if text has {}
  const checkIfTextHasBrackets = text.includes("{");

  if (checkIfTextHasBrackets) {
    // get text from start string to first brackets {
    const stringStart = text.match(/.*?(?=\{)/);

    // get text from last brackets } to end string
    const stringEnd = text.match(/\}(.*$)/);

    // get text between brackets {}
    const textBetweenBrackets = text.match(/\{([^}]+)\}/);

    text = `<a href="/?${
      textBetweenBrackets[1]
    }">${stringStart[0].trim()}</a> ${stringEnd[1]}`;
  }

  return `
    <div class="custom-info" data-custom-info-text="${textData}">
      <div class="p-0 container-lg system-message-ticker">
        <div id="smarquee" class="custon-info-message">${text}</div>
      </div>
    </div>`;
}
